import { headerJs } from './header';
import accordion from './helpers/accordion';
import activeToggle from './helpers/activeAccordion';

headerJs()

const accordions = document.querySelectorAll('[data-js="accordion"]')

setTimeout(() => {
    accordions.forEach((elem, index) => {
        accordion(elem, true);
    });
    activeToggle(accordions[0]);
    accordions[0].querySelector('[data-js="accordion-toggler"]').setAttribute('aria-expanded', "true")

}, 100)